import styled from 'styled-components';

export const Section = styled.section`
  padding: 0px 160px;
  position: relative;
  background: #F7F5F5;
  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding: 0px 16px;
  }
`;

export const Container = styled.div`
  padding-bottom: 128px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding-bottom: 0;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 2;
  
`;

export const Title = styled.h2`
  font-size: 48px;
  font-weight: bold;
  color: ${({ theme }) => theme.global.colors.black};

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    font-size: 2.5rem;
  }
`;

export const Description = styled.p`
  margin-top: 1rem;
  color: ${({ theme }) => theme.global.colors.grey};
  font-size: 18px;
`;

export const ImageRight = styled.img`
  width: 433px;
  height: auto;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
   display: none;
  }
`;

export const BenefitSection = styled.div`
  display: flex;
  padding: 64px 0;
  align-items: center;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    padding-top: 0;
  }
`;

export const CurveCircle = styled.div`
  background: #e0f5e8;
  width: 739px;
  height: 739px;
  border-radius: 50%;
  position: absolute;
  top: 33px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    display: none;
  }
`;

export const ImageLeft = styled.img`
  position: relative;
  width: 433px;
  heigth: auto;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    width: 358px;
  }
`;

export const Subtitle = styled.h3`
  font-size: 32px;
  font-weight: bold;
  margin-bottom:0;
  z-index: 2;
  position: relative;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  z-index: 2;
  max-width:600px;
`;

export const ListItem = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px 16px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  

  strong {
    color: ${({ theme }) => theme.global.colors.primary};
    font-weight: bold;
    font-size: 32px;
  }

  p {
  font-size: 18px;
  margin-bottom:0;
    color: ${({ theme }) => theme.global.colors.grey};
  }
`;
